if (document.getElementsByClassName('js-inCount')[0]) {
  module()
}
function module() {
  //   ####   #####   ##   ##  ##     ##  ######
  //  ##     ##   ##  ##   ##  ####   ##    ##
  //  ##     ##   ##  ##   ##  ##  ## ##    ##
  //  ##     ##   ##  ##   ##  ##    ###    ##
  //   ####   #####    #####   ##     ##    ##
  /*
  画面に入った数字データのカウントアップまたはカウントダウン

  data-count-start 初期値
  data-count-end 最終値　小数や負の値にも対応
  data-count-step 1ループ毎の増加値　省略で自動計算

<span class="js-inCount" data-count-start="0" data-count-end="50" data-count-step="">0</span>
<br>
<span class="js-inCount" data-count-start="0" data-count-end="100" data-count-step="">0</span>
<br>
<span class="js-inCount" data-count-start="0" data-count-end="1500.05" data-count-step="">0</span>
<br>
<span class="js-inCount" data-count-start="0" data-count-end="-15450.995" data-count-step="">0</span>
<br>
<span class="js-inCount" data-count-start="0" data-count-end="500" data-count-step="1">0</span>
  */
  //

  //            ##  ##     ##
  //            ##  ####   ##
  //  ########  ##  ##  ## ##
  //            ##  ##    ###
  //            ##  ##     ##
  // 画面に入った監視対象をカウントアップ
  // Intersection Observer
  window.intObsCount = function () {
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: '-20px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.querySelectorAll('.js-inCount:not(.counted)')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('counted')

          const countStart = parseFloat(entryItem.dataset.countStart) // 初期値
          const countEnd = parseFloat(entryItem.dataset.countEnd) // 最終値
          let countStep = parseFloat(entryItem.dataset.countStep) // ステップ

          // ステップがなければ自動計算
          if (!countStep) {
            countStep = (countEnd - countStart) * 0.03 // 総カウント量の3%

            const decimalLength = getDecimalLength(countEnd) // 小数の桁数
            countStep = countStep.toFixed(decimalLength) // ステップの小数桁数を最終値と揃える
            countStep = parseFloat(countStep)

            // console.log(countStep)
            if (countStep <= 0) {
              countStep = Math.pow(10, -decimalLength) || 1
            }
          }

          valCountUp(entryItem, countStart, countEnd, countStep)

          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
  window.intObsCount() // 画面交差API起動

  //             ####   #####   ##   ##  ##     ##  ######
  //            ##     ##   ##  ##   ##  ####   ##    ##
  //  ########  ##     ##   ##  ##   ##  ##  ## ##    ##
  //            ##     ##   ##  ##   ##  ##    ###    ##
  //             ####   #####    #####   ##     ##    ##
  // 再帰的なカウント描画
  function valCountUp(item, countStart, countEnd, countStep = 1) {
    if (countStart !== countEnd) {
      // 途中表示の補正処理
      const decimalLength = getDecimalLength(countEnd) // 小数の桁数
      countStart = countStart.toFixed(decimalLength) // ステップの小数桁数を最終値に揃える
    }

    const formatted = Number(countStart).toLocaleString()
    const countSplit = formatted.split('.')

    // 値を反映
    item.innerHTML = '<span class="">' + countSplit[0] + '</span>'
    if (countSplit[1]) {
      // 小数がある場合表示を追加
      item.innerHTML = item.innerHTML + '</span><span class="">.</span>' + '<span class="">' + countSplit[1] + '</span>'
    }

    if (countStart === countEnd) {
      // 数えきったら終了
      return
    }

    countStart = parseFloat(countStart) // 表示用補正で文字列になっているのでfloatに直す

    countStart += countStep // カウントを進める

    // 判定用の絶対値を求める
    const countStartAbs = Math.abs(countStart)
    const countEndAbs = Math.abs(countEnd)

    if (countStartAbs > countEndAbs) {
      // オーバーしたら最大値に揃える
      countStart = countEnd
    }

    // 再帰呼び出し
    let timerVal = 5 // カウントマイクロ秒
    const progress = countStartAbs / countEndAbs // 進捗を求める

    // 進捗に応じて加減速
    if (progress <= 0.3) {
      timerVal = 2
    } else if (progress <= 0.6) {
      timerVal = 5
    } else if (progress <= 0.7) {
      timerVal = 40
    } else if (progress <= 0.8) {
      timerVal = 60
    } else if (progress <= 0.9) {
      timerVal = 80
    } else if (progress <= 1) {
      timerVal = 100
    }
    setTimeout(function () {
      valCountUp(item, countStart, countEnd, countStep)
    }, timerVal)
  }

  //            #####  ##   ##  ##     ##   ####
  //            ##     ##   ##  ####   ##  ##
  //  ########  #####  ##   ##  ##  ## ##  ##
  //            ##     ##   ##  ##    ###  ##
  //            ##      #####   ##     ##   ####
  // 小数の桁数を取得する
  function getDecimalLength(number) {
    const numbers = String(number).split('.')

    return numbers[1] ? numbers[1].length : 0
  }
}
